// DEPOIS — idConta volta ao state, só para injetar no create
import { defineStore } from 'pinia';
import { CreateEtiqueta, EtiquetaService, ResponseEtiqueta, UpdateEtiqueta } from '@/services/etiquetas/etiquetas.service';
import { ContatoEtiquetaService } from '@/services/contatos-etiquetas/contatos-etiquetas.service';
import { GrupoEtiquetaService } from '@/services/grupos-etiquetas/grupos-etiquetas.service';
import { IdConta, IdContato, IdEtiqueta, IdGrupo } from '@/services/common-types';

export const useTagStore = defineStore('tags', {
    state: () => ({
        initialized  : false as boolean,
        idConta      : null as IdConta | null,
        availableTags: [] as ResponseEtiqueta[],

        tagService       : new EtiquetaService(),
        tagContatoService: new ContatoEtiquetaService(),
        tagGrupoService  : new GrupoEtiquetaService(),
    }),

    actions: {
        async init(idConta: IdConta) {
            if (!idConta) throw new Error('[tagStore] Store inicializada sem ID conta.');
            this.idConta = idConta;
            this.availableTags = await this.tagService.getAllByConta(idConta);
            this.initialized = true;
            return this;
        },

        async fetchTags() {
            this.throwIfUninitialized();
            this.availableTags = await this.tagService.getAllByConta(this.getThisIDContaOrThrow());
            return this.availableTags;
        },

        async fetchTagsByContato(idContato: IdContato) {
            this.throwIfUninitialized();
            return await this.tagContatoService.getEtiquetasByContato(idContato);
        },

        async fetchTagsByGrupo(idGrupo: IdGrupo) {
            this.throwIfUninitialized();
            return await this.tagGrupoService.getEtiquetasByGrupo(idGrupo);
        },
        
        async createTag(tag: CreateEtiqueta) {
            this.throwIfUninitialized();
            const res = await this.tagService.create({
                ...tag,
                idConta: this.getThisIDContaOrThrow(), // injeta idConta transparentemente
            });
            await this.fetchTags();
            return res;
        },

        async updateTag(tag: UpdateEtiqueta) {
            this.throwIfUninitialized();
            const res = await this.tagService.update(tag);
            await this.fetchTags();
            return res;
        },

        async deleteTag(tagId: IdEtiqueta) {
            this.throwIfUninitialized();
            const res = await this.tagService.delete(tagId);
            await this.fetchTags();
            return res;
        },

        async bindTag(idTag: IdEtiqueta, idContato: IdContato) {
            this.throwIfUninitialized();
            const res = await this.tagContatoService.create({idContato, idEtiqueta: idTag});
            await this.fetchTags();
            return res;
        },

        async unbindTag(idTag: IdEtiqueta, idContato: IdContato) {
            this.throwIfUninitialized();
            const res = await this.tagContatoService.remove(idContato, idTag);
            await this.fetchTags();
            return res;
        },

        // Substitui todos os vínculos de etiquetas do contato pela lista informada.
        // Lista vazia remove todos os vínculos.
        async syncTagsContato(idContato: IdContato, idEtiquetas: IdEtiqueta[]) {
            this.throwIfUninitialized();
            return await this.tagContatoService.sync(idContato, idEtiquetas);
        },

        async bindTagToGrupo(idTag: IdEtiqueta, idGrupo: IdGrupo) {
            this.throwIfUninitialized();
            const res = await this.tagGrupoService.create({ idGrupo, idEtiqueta: idTag });
            await this.fetchTags();
            return res;
        },

        async unbindTagFromGrupo(idTag: IdEtiqueta, idGrupo: IdGrupo) {
            this.throwIfUninitialized();
            const res = await this.tagGrupoService.remove(idGrupo, idTag);
            await this.fetchTags();
            return res;
        },

        getThisIDContaOrThrow() {
            if (!this.idConta) throw new Error('[tagStore] `this.idConta` was `null`.');
            return this.idConta
        },
        throwIfUninitialized() {
            if (!this.initialized) throw new Error('[tagStore] Método chamado sem inicializar a store.');
        },
    },
});